import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function Section({ children, description, title, type }) { // eslint-disable-line require-jsdoc
    return (
        <section
            className={classNames('style-guide-section', {
                'constrain-width': type === 'constrain'
            })}
            id={`section-${encodeURI(title.toLowerCase())}`}>
            <header
                className={classNames('style-guide-section-header', {
                    'constrain-width': type !== 'constrain'
                })}>
                <h2 className="style-guide-section-title">{title}</h2>
                {description && <p>{description}</p>}
            </header>
            {children}
        </section>
    );
}

Section.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.array
    ]),
    description: PropTypes.string,
    title: PropTypes.string.isRequired,
    type: PropTypes.string
};

export default Section;
